import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { device } from "web_myplann/Utils/device";

type Variables = {
	id: number;
	filename: string;
};

export const useRemoveSavedDocumentMutation = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: DocumentKeys.transfer,
		mutationFn: async ({ id, filename }: Variables) => {
			const response = await device.removeAttachment(filename, id);
			if (!response.payload.success) {
				throw new Error(t(Resources.Common.somethingWentWrong));
			}
			return response.payload.savedDocumentIds;
		},
		onSuccess: (savedDocumentIds) => {
			if (savedDocumentIds) {
				queryClient.setQueryData(DocumentKeys.saved, savedDocumentIds);
				return;
			}
			queryClient.invalidateQueries({ queryKey: DocumentKeys.saved });
		},
	});
};
